import { FC } from 'react';

import { AvatarIconStyled, AvatarPlaceholderStyled, AvatarWrapStyled } from './Avatar.styled';

type AvatarPropsT = {
  placeholder: string;
  imageUrl?: string;
  size?: 'sm' | 'md' | 'lg';
};

const Avatar: FC<AvatarPropsT> = ({ imageUrl, placeholder, size }) => (
  <AvatarWrapStyled size={size}>
    {imageUrl ? (
      <AvatarIconStyled imageUrl={imageUrl} />
    ) : (
      <AvatarPlaceholderStyled size={size}>{placeholder}</AvatarPlaceholderStyled>
    )}
  </AvatarWrapStyled>
);

export default Avatar;
